module.exports = __webpack_public_path__ + "static/img/shopping-cart.b246ade.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopping-cart.svg
// module id = zHu8
// module chunks = 134